"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.simulateServerSide = exports.simulateClientSide = exports.isClientSide = exports.isClientSideInternalTest = void 0;
var simulatedClientMode = null;
function isClientSideInternalTest(window, process) {
    if (simulatedClientMode != null) {
        return simulatedClientMode;
    }
    if (process != null && process.env != null && process.env.NODE_ENV != null) {
        return process.env.NODE_ENV === 'test' ? null : false;
    }
    return typeof window !== 'undefined';
}
exports.isClientSideInternalTest = isClientSideInternalTest;
function isClientSide() {
    return isClientSideInternalTest(typeof window !== 'undefined' ? window : undefined, process);
}
exports.isClientSide = isClientSide;
function simulateClientSide(callback) {
    var oldSimulatedClientMode = simulatedClientMode;
    simulatedClientMode = true;
    try {
        callback();
    }
    finally {
        simulatedClientMode = oldSimulatedClientMode;
    }
}
exports.simulateClientSide = simulateClientSide;
function simulateServerSide(callback) {
    var oldSimulatedClientMode = simulatedClientMode;
    simulatedClientMode = false;
    try {
        callback();
    }
    finally {
        simulatedClientMode = oldSimulatedClientMode;
    }
}
exports.simulateServerSide = simulateServerSide;
//# sourceMappingURL=EnvironmentTest.js.map